import React from "react";

import "./FooterBar.css";

const FooterBar = (props) => {
  return (
    <div className="footer">
      <span>
        &copy; {new Date().getUTCFullYear()} Copyright:{" "}
        <a> Be One Solutions </a>
      </span>
    </div>
  );
};

export default FooterBar;
